import { render } from "./SkillCard.vue?vue&type=template&id=7987624e&scoped=true"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"

import "./SkillCard.vue?vue&type=style&index=0&id=7987624e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7987624e"]])

export default __exports__